module.exports = __webpack_public_path__ + "static/media/customer_empty@3x.27f2a400.png";